const defaultMainText = `IMAGE TEMPLATE`
export default defaultMainText